import React from "react";
import { motion } from "framer-motion";
import {
  Award,
  Map,
  Zap,
  PackageCheck,
  Cpu,
  HeartHandshake,
} from "lucide-react";

const features = [
  {
    icon: Award,
    title: "10+ years in vending",
    desc: "Operator-led expertise across diverse Indian sites.",
  },
  {
    icon: PackageCheck,
    title: "Outright ownership",
    desc: "You buy the asset. No monthly fees, full margin stays with you.",
  },
  {
    icon: Map,
    title: "Pan-India service",
    desc: "Technicians and spare parts across major cities.",
  },
  {
    icon: Zap,
    title: "Zero-downtime AMC",
    desc: "Remote diagnostics, planned visits and a fast-response network.",
  },
  {
    icon: Cpu,
    title: "Smart-software ready",
    desc: "UPI, cards, telemetry and inventory dashboards out of the box.",
  },
  {
    icon: HeartHandshake,
    title: "Customer-first ops",
    desc: "Backed by a decade of business management — fast resolution, clear ownership.",
  },
];

export default function WhyUs() {
  return (
    <section
      id="why-us"
      data-testid="why-us-section"
      className="relative py-24 md:py-32 bg-zinc-50"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="text-[11px] uppercase tracking-[0.25em] text-amber-600 mb-3">
              Why Thecoventures
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tighter text-zinc-950">
              Sell smarter.
              <br />
              <span className="text-zinc-500">Run leaner.</span>
            </h2>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {features.map((f, i) => {
            const Icon = f.icon;
            return (
              <motion.div
                key={f.title}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.45, delay: (i % 3) * 0.06 }}
                data-testid={`why-us-card-${i}`}
                className="group rounded-2xl border border-zinc-200 bg-white p-6 hover:border-emerald-400 hover:shadow-lg hover:shadow-zinc-900/5 transition"
              >
                <div className="w-11 h-11 rounded-xl bg-emerald-50 border border-emerald-100 flex items-center justify-center text-emerald-600 group-hover:bg-amber-50 group-hover:text-amber-600 group-hover:border-amber-100 transition-colors">
                  <Icon className="w-5 h-5" />
                </div>
                <h3 className="mt-5 font-display text-lg font-semibold text-zinc-950 tracking-tight">
                  {f.title}
                </h3>
                <p
                  className="mt-2 text-sm text-zinc-600 leading-relaxed"
                  dangerouslySetInnerHTML={{ __html: f.desc }}
                />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
